import { render, staticRenderFns } from "./rp-users-tip.vue?vue&type=template&id=4d0c72f6"
import script from "./rp-users-tip.vue?vue&type=script&lang=js"
export * from "./rp-users-tip.vue?vue&type=script&lang=js"
import style0 from "./rp-users-tip.vue?vue&type=style&index=0&id=4d0c72f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports